module.exports = __webpack_public_path__ + "assets/202509252035/img/verticalTimeline.458cfc2e.png";